module.exports = __webpack_public_path__ + "static/media/O1.eb79f3ab.png";